import { useState } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import API from "../api";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await API.post("/forgot-password", {
                email,
            })
            setSuccessMessage(response.data.message)
        } catch(error) {
            setErrorMessage('An error has occured')

        }
    };

    return (
        <div className="relative min-h-screen bg-[#0D1117] flex items-center justify-center px-4 sm:px-6 lg:px-8">
            <Header />

            {/* Background graphique */}
            <div className="absolute bottom-0 right-0 overflow-hidden lg:inset-y-0">
                <div className="w-auto h-full bg-gradient-to-tr from-[#1F6FEB]/20 to-[#3B82F6]/10 rounded-full transform rotate-45 scale-150"></div>
            </div>

            {/* Formulaire */}
            <div className="relative z-10 w-full max-w-md bg-[#161B22] rounded-2xl shadow-[0_0_20px_#3B82F6]/20 p-8 mt-20">
                <h2 className="text-3xl font-bold text-center text-[#E6EDF3] mb-2 font-pj">
                    Forgot Password 🔒
                </h2>
                <p className="text-center text-[#8B949E] mb-8">
                    Enter your email and we will send you a link to reset your password.
                </p>

                <form className="space-y-5" onSubmit={handleSubmit}>
                    <div>
                        <label className="block text-[#8B949E] mb-1 font-medium">Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full px-4 py-3 border border-[#30363D] rounded-xl focus:ring-2 focus:ring-[#1F6FEB] focus:outline-none bg-[#0D1117] text-[#E6EDF3] placeholder-[#6E7681]"
                            placeholder="you@example.com"
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        className="w-full py-3 mt-4 text-white bg-[#1F6FEB] hover:bg-[#388BFD] rounded-xl font-semibold transition shadow-[0_0_10px_#1F6FEB]/30"
                    >
                        Send Reset Link
                    </button>
                </form>

                {successMessage && (
                    <p className="text-green-400 text-sm mt-4 text-center">{successMessage}</p>
                )}
                {errorMessage && (
                    <p className="text-red-500 text-sm mt-4 text-center">{errorMessage}</p>
                )}

                <p className="text-center text-[#8B949E] mt-6">
                    Remember your password?{" "}
                    <Link to="/login" className="font-semibold text-[#1F6FEB] hover:underline">
                        Login
                    </Link>
                </p>
            </div>
        </div>
    );
}

